
let observer;

const questionImageMap = {
    "68dbbea27fd3905ff88211a7":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-1-INTRO.jpg?v=1777031395",
    "68dbbec97fd3905ff88211e1":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-2-SKINTYPE-FACE.jpg?v=1777031441",
    "68dbbef47fd3905ff882124e":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970bf0e1dbd7121163bbde5":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970bff61dbd7121163bbea3":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970c0481dbd7121163bbf10":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970c08c1dbd7121163bbf76":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970c0d11dbd7121163bbfdc":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "6970c1141dbd7121163bc03b":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-3-CONCERN-FACE.jpg?v=1777031427",
    "68dbbf637fd3905ff88212bf":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-4-ALT-FACE-1.jpg?v=1777031354",
    "68dbbfb57fd3905ff882131d":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-5-ALT-FACE-2.jpg?v=1777031335",
    "68dbbfd57fd3905ff8821382":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-6-ALT-FACE-3.jpg?v=1777031414",
    "68e3a4e67fd3905ff88631af":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-7-CONCERN-FACE.jpg?v=1777031320",
    "68dbbffd7fd3905ff88213ed":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-9-SKINTYPE-BODY.jpg?v=1777031291",
    "68dbc02b7fd3905ff8821415":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-10-CONCERN-BODY.jpg?v=1777031383",
    "6971c8871dbd7121163c7be5":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971c3be1dbd7121163c7a4b":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971c4e81dbd7121163c7ada":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971c9ae1dbd7121163c7d6b":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971caba1dbd7121163c7e53":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971cba11dbd7121163c7f33":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "6971c5351dbd7121163c7b47":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-11-ALT-BODY-1.jpg?v=1777031455",
    "68dbbe8f7fd3905ff8821132":"https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-12-RESULTS-BODY.jpg?v=1777031306"
};

const main          = document.querySelector("#tangent-main-container");
const quizContainer = document.querySelector("#quiz-container");
const quizBlock     = document.querySelector("#quiz-block");
const imageEl       = document.getElementById("quiz-image-element");
const progressbar   = document.getElementById("tangent-progress-bar");

const isMobile = () => window.matchMedia("(max-width: 600px)").matches;

const preloadedImages = [];

function preloadQuestionImages(imageMap) {
    const uniqueUrls = [...new Set(Object.values(imageMap))];

    return Promise.all(
        uniqueUrls.map(url => {
            return new Promise((resolve, reject) => {
                const img = new Image();

                img.onload = () => {
                    console.log("Loaded:", url);
                    resolve(url);
                };

                img.onerror = () => {
                    console.warn("Failed:", url);
                    reject(url);
                };

                img.src = url;

                // keep reference so browser doesn't garbage collect
                preloadedImages.push(img);
            });
        })
    );
}

window.addEventListener("load", () => {
    preloadQuestionImages(questionImageMap);
});

function startHeightSync(questionId) {
  if (!main || !quizContainer) return;

  if (observer) observer.disconnect();

  observer = new ResizeObserver(([entry]) => {
    let h = entry.contentRect.height + 150;
    if (!h) return;

    
    
    quizContainer.style.setProperty("min-height", `${h}px`, "important");

    if (isMobile()) {
        let mobileHeight = h;

        // cut short extra height for all except one question
        if (questionId !== "68dbbef47fd3905ff882124e") {
            mobileHeight -= 80;
        }

        quizBlock.style.setProperty(
            "min-height",
            `${mobileHeight}px`,
            "important"
        );
    }

    if (imageEl) {
      imageEl.style.height = `${h}px`;
      imageEl.style.objectFit = "cover";
    }
  });

  observer.observe(main);
}

window.addEventListener("react_quiz_loaded", () => {
  // slight delay to allow Tangent to inject DOM
  setTimeout(startHeightSync, 300);
});

let questionId = null;
let questionIndex = -1;

window.addEventListener("quiz_progress", (event) => {
    const parts = event.detail.split("_");
    const current = Number(parts[0]);
    const total = Number(parts[1]);
    const nextQuestionId = parts[3];

    let imageUrlToSet;

    if (questionId === nextQuestionId) {
        // Same question fired again
        imageUrlToSet = questionImageMap[nextQuestionId];

    } else if (
        questionId === "68e3a4e67fd3905ff88631af" &&
        current > questionIndex
    ) {
        // Leaving disclaimer question going forward:
        // keep showing results face image for this transition
        imageUrlToSet = "https://cdn.shopify.com/s/files/1/0105/2265/6823/files/NATR-032726-Quiz-8-RESULTS-FACE.jpg?v=1777031368";

    } else {
        imageUrlToSet = questionImageMap[nextQuestionId];
    }

    // Update state after deciding image
    questionId = nextQuestionId;
    questionIndex = current;

    if (imageUrlToSet) {
        imageEl.src = imageUrlToSet;
    }

    progressbar.style.width = `${(current / total) * 100}%`;

    if (questionId === "68e3a4e67fd3905ff88631af") {
        addDisclaimerText();
    }

    requestAnimationFrame(() => startHeightSync(questionId));
});

function addDisclaimerText() {

    const observer = new MutationObserver(() => {
        const parent = document.getElementById("comp_68dbbe8f7fd3905ff8821132");
        if (!parent) return;

        const secondDiv = parent.querySelector("div:nth-child(2)");
        if (!secondDiv) return;

        if (parent.querySelector(".custom-disclaimer")) return;

        const textElement = document.createElement("p");
        textElement.className = "custom-disclaimer";

        textElement.innerHTML = `By clicking “Submit", you agree to 
            <a href="https://naturium.com/pages/terms-conditions-rewards" target="_blank"><u>Consistency Club Terms and Conditions</u></a> 
            as well as Naturium’s 
            <a href="https://naturium.com/pages/terms-of-service" target="_blank"><u>Terms of Use</u></a> and 
            <a href="https://naturium.com/pages/privacy-policy-2" target="_blank"><u>Privacy Notice</u></a>, 
            including Naturium’s Notice of Financial Incentive.`;

        textElement.style.fontSize = "12px";
        textElement.style.color = "#666";
        textElement.style.marginTop = "6px";
        textElement.style.marginBottom = "25px";
        textElement.style.width="99%";
        secondDiv.style.gap="0";
        // {% comment %} secondDiv.insertAdjacentElement("afterend", textElement); {% endcomment %}
        secondDiv.appendChild(textElement);
        observer.disconnect(); // stop once added
    });

    observer.observe(document.body, { childList: true, subtree: true });
}
